module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/sp/common/icon_tel-a0b72396a5b698ed5553309c9be8203b.svg";